//css
// 1、公共部分
import "../public/css/global.css";
import "../public/css/commonHead.css";
import "../public/css/messageDialogBox.css";
import "../public/css/dataEditModal.css";
// 20251028：signupAndLogin.ejs 页面不再做为单独访问页面管理
import "../public/css/signupAndLogin.css";
import "../public/css/commonFooter.css";
// 2、独有部分
import "../public/css/blogAndForum/forum-dev.css";
import "../public/css/blogAndForum/post-detail-dev.css";
import "../public/css/blogAndForum/Forum-Individual.css";
import "../public/css/blogAndForum/post-create.css";

// JS:
// 1、公共部分
import '../public/js/common/appVariables.js';  // 20260905 Add，要优先于 indexedDBManager.js
// 20251119：只需在 commonHead 入口中包含即可，其它入口不需要再包含！-> 
// 20260420 取消 commonHead 入口，改为自己 SPA 页面自己管理
import '../public/js/common/pagesMessageBus.js';  // 这是基础设施，优先加载初始化！

import '../public/js/common/mountGlobalObjects.js';
import '../public/js/common/axiosInterceptor.js';  // 20260905 Add

import '../public/js/socialInteraction.js';  // 保证在业务代码模块之前尽早加载

import '../public/js/commonHead.js';
import '../public/js/messageDialogBox.js';
import '../public/js/common/clickFlame.js';
import '../public/js/dataEditModal.js'
import '../public/js/common/pagaDataLifeCycleManager.js'  // 20260420
import '../public/js/common/indexedDBManager.js';  // 20260420
// 20251028：signupAndLogin.ejs 页面不再做为单独入口页面管理
import '../public/js/signupAndLogin.js';
// 开发阶段不引用该脚本，正式上线时测试后引入
// import '../public/js/commonFooter.js';

// 2、独有部分
import '../public/js/blogAndForum/router.js';
import '../public/js/blogAndForum/global.js';
//只保留一个router.js（静态import），其余子页面用动态依赖的方式加载
// import '../public/js/blogAndForum/forum-home.js';
// import '../public/js/blogAndForum/forum-module.js';
// import '../public/js/blogAndForum/post-detail-home.js';
// import '../public/js/blogAndForum/post-detail.js';
// import '../public/js/blogAndForum/Forum-Individual-home.js';
// import '../public/js/blogAndForum/Forum-Individual.js';
// import '../public/js/blogAndForum/post-create-home.js';
// import '../public/js/blogAndForum/post-create.js';